import React, { useCallback } from 'react';
import { Modal, ModalBody, Button, Form, ModalHeader } from 'reactstrap';
import * as EmployeeAction from 'store/actions/employee';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { fetchInvoiceNumber } from 'services/commercialInvoice';
import BasicInfoForm from './../basicInfoForm';
import ItemInfoForm from './../itemInfoForm';
import CostInfoForm from './../costInfoForm';
import AdressInputForm from 'pages/information/addressbook/inputForm';
import SelectDepositInvoiceDialog from './../selectDepositInvoiceDialog';
import './add-dialog.scss';
import { t } from 'i18next';

export default function AddDialog({ modalOpen, onToggle, onSubmit, editData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      items: [
        {
          itemname: '',
          unit: '',
          qty: 1,
          amount: '',
          remark: '',
        },
      ],
    },
  });

    const [selectedOrder, setSelectedOrder] = React.useState(null);


  const submitData = async (values) => {
    if (editData) {
      values.isEdit =true;
    }
    onSubmit(values);
  };

  const [selectedAddress, setSelectedAddress] = React.useState(null);
  const [showDepositInvoiceDialog, setShowDepositInvoiceDialog] = React.useState(false);

  const dispatch = useDispatch();
  const countries = useSelector((state) => state.location.countries);

  const setInitValue = useCallback((data) => {

    
    setValue('basicinfo.ref_no', data?.ref_no);
    setValue('basicinfo.license_no', data?.license_no);
    setValue('basicinfo.quotation_no', data?.deposit_invoice?.quotation_no);
    setValue('basicinfo.invoice_date', data?.invoice_date);
    setValue('basicinfo.currency', data?.currency || 'MMK');
    setValue('costinfo.paymentType', data?.paymentType?._id);
    setValue('costinfo.other_service_charges', data?.other_service_charges || 0);
    setValue('basicinfo.destination',data?.destination?._id)
    
    // Set items array if exists
    if (editData) {
      setValue('items', data.items); if (data?.items && data.items.length > 0) {
        setValue('items', data.items);
      }
      setValue('basicinfo.invoice_no', data?.invoice_number);
    }
   
    setValue('senderinfo', data.sender);
    setValue('senderinfo.code', data.address_code);
    setValue('senderinfo.marketing_person', data.sale_person?._id);

    setValue('receiverinfo', data.receiver);
    setSelectedAddress({branch:{name:data?.destination?.name},marketing_person:{name:data?.sale_person?.name}})

    
  }, [editData]);

  React.useEffect(() => {
    if (editData) {
      setInitValue(editData);
    } else {
      reset({
        items: [
          {
            itemname: '',
            unit: '',
            qty: 1,
            amount: '',
            remark: '',
          },
        ],
      });
    }
  }, [editData, getValues, reset, setValue]);

  

  React.useEffect(() => {
    dispatch(EmployeeAction.getMarketingPerson());
  }, [dispatch, EmployeeAction.getMarketingPerson]);

  const onFetchInvoiceNumber = async () => {
    const response = await fetchInvoiceNumber();
    if (response) {
      setValue('generated_invoice_number', response);
      setValue('basicinfo.invoice_no', response.invoice_number);
    }
  };

  const handleSelectDepositInvoice = (invoice) => {
    setInitValue(invoice);
    setSelectedOrder(invoice);
    setValue('basicinfo.ref_no', invoice.invoice_number);
    setValue('basicinfo.quotation_no', invoice.quotation_no);
    setShowDepositInvoiceDialog(false);
  };

  return (
    <Modal
      isOpen={modalOpen}
      size='lg'
      style={{
        maxWidth: '1400px',
        width: '80%',
        minWidth: 400,
      }}
      backdrop={true}
    >
      {editData && (
        <ModalHeader style={{ background: '#e9e9ef' }}>
          <div>
            <h3>Invoice Number : {editData.invoice_number}</h3>
          </div>
        </ModalHeader>
      )}
      <ModalBody
        style={{
          maxHeight: '85vh',
          overflowY: 'auto',
        }}
      >
        <Form onSubmit={handleSubmit(submitData)} className='order-modal'>
          <BasicInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            editData={editData}
            watch={watch}
            selectedAddress={selectedAddress}
            onFetchInvoiceNumber={onFetchInvoiceNumber}
            onSelectDepositInvoice={() => setShowDepositInvoiceDialog(true)}
          />

          <div className='divider'></div>
          <AdressInputForm
            register={register}
            errors={errors}
            control={control}
            options={{ countries: countries }}
            editData={editData}
            addNew={false}
            setValue={setValue}
            types={['senderinfo', 'receiverinfo']}
            getValues={getValues}
            onSelectAddress={(address) => {
              setSelectedAddress(address);
            }}
            selectedOrder={selectedOrder}
            noCard={true}
          />
          <div className='divider'></div>
          <ItemInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            editData={editData}
            getValues={getValues}
          />
          <div className='divider'></div>
          <CostInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            getValues={getValues}
          />
          <div className='custom-modal-footer'>
            <Button color='success' type='button' onClick={() => onToggle(!modalOpen)}>
              {t('cancel')}
            </Button>
            <Button color='primary' type='submit'>
              {t('submit')}
            </Button>
          </div>
        </Form>
      </ModalBody>

      {/* Deposit Invoice Selection Dialog */}
      <SelectDepositInvoiceDialog
        modalOpen={showDepositInvoiceDialog}
        onToggle={setShowDepositInvoiceDialog}
        onSelect={handleSelectDepositInvoice}
      />
    </Modal>
  );
}
